module.exports = __webpack_public_path__ + "static/1-53d68a027c986a25d706d46a599b9d0b.jpg";